import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBorderSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 292,
	height: 202,
	viewBox: "0 0 292 202",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 291,
		height: 200,
		rx: 9.5,
		strokeDasharray: "10 10"
	})
});
export default SvgBorderSmall;
